import React from 'react';
import {
    Grid,
    Paper,
    Typography,
    Box,
    CircularProgress,
    Alert,
    List,
    ListItem,
    ListItemText,
    ListItemAvatar,
    Avatar,
    Divider,
    Chip
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useRTL } from '../../../hooks/useRTL';
import { COLORS } from '../../../utils/constants';

const TopDoctors = ({ analytics, analyticsLoading, error }) => {
    const { t } = useTranslation();
    const { containerProps } = useRTL();

    if (analyticsLoading) {
        return (
            <Grid item xs={12} md={8}>
                <Paper sx={{ p: 3, ...containerProps }}>
                    <Typography variant="h6" gutterBottom>
                        {t('dashboard.topRatedDoctors')}
                    </Typography>
                    {error ? (
                        <Alert severity="error">{error}</Alert>
                    ) : (
                        <Box display="flex" justifyContent="center" alignItems="center" minHeight="300px">
                            <CircularProgress />
                        </Box>
                    )}
                </Paper>
            </Grid>
        );
    }

    return (
        <Grid item xs={12} md={8}>
            <Paper sx={{ p: 3, ...containerProps }}>
                <Typography variant="h6" gutterBottom>
                    {t('dashboard.topRatedDoctors')}
                </Typography>
                <List>
                    {analytics.topRatedDoctors?.map((doctor, index) => {
                        const doctorName = doctor.name || t('common.unknown');

                        // --- FIX STARTS HERE ---
                        // The API provides the specialization as an object for some doctors, and null for others.
                        // We need to safely access the name.
                        const specializationName = doctor.specialization?.name;
                        // --- FIX ENDS HERE ---

                        return (
                            <React.Fragment key={doctor._id}>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar sx={{ bgcolor: COLORS[index % COLORS.length] }}>
                                            {doctorName.charAt(0) || 'D'}
                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={
                                            <Typography>
                                                {doctorName}
                                            </Typography>
                                        }
                                        secondary={
                                            <Box component="span" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mt: 0.5 }}>
                                                {/* --- FIX: Only display specialization if it exists --- */}
                                                {specializationName && (
                                                    <Typography
                                                        variant="body2"
                                                        color="textSecondary"
                                                        component="span"
                                                        display="block"
                                                        sx={{ mb: 0.5 }}
                                                    >
                                                        {specializationName}
                                                    </Typography>
                                                )}

                                                {/* --- FIX: Display the available appointmentCount instead of rating/completed --- */}
                                                <Chip
                                                    size="small"
                                                    label={`${doctor.appointmentCount} ${t('dashboard.appointments', 'Appointments')}`}
                                                    color="primary"
                                                    variant="outlined"
                                                />
                                            </Box>
                                        }
                                    />
                                </ListItem>
                                {index < analytics.topRatedDoctors.length - 1 && <Divider />}
                            </React.Fragment>
                        );
                    })}
                </List>
            </Paper>
        </Grid>
    );
};

export default TopDoctors;